const map = {
	"./articles.js": 63888,
	"./categories.js": 57475,
	"./category.js": 10991,
	"./folderStructure.js": 81250,
	"./index.js": 28603,
	"./masterView.js": 61148,
	"./periods.js": 8185,
	"./query.js": 35323,
	"./settings.js": 33262,
	"./standardBreakdown.js": 97011,
	"./standardBreakdowns.js": 96822
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71601;